module.exports = __webpack_public_path__ + "img/energy_6.0f283462.png";